import {equals} from 'ol/coordinate.js';
import olFeature from 'ol/Feature.js';
import {unByKey} from 'ol/Observable.js';
import olGeomPoint from 'ol/geom/Point.js';
import olStyleStyle from 'ol/style/Style.js';
import olStyleText from 'ol/style/Text.js';
import olStyleFill from 'ol/style/Fill.js';
import olStyleStroke from 'ol/style/Stroke.js';
import olStyleCircle from 'ol/style/Circle.js';
import olSourceVector from 'ol/source/Vector.js';
import olEventsEventType from 'ol/events/EventType.js';
import olStyleIcon from 'ol/style/Icon.js'
import {listen} from 'ol/events.js';
import olLayerVector from 'ol/layer/Vector.js';
import olFormatGeoJSON from 'ol/format/GeoJSON.js';

/** @suppress {extraRequire} */
import ngeoToolActivate from 'ngeo/misc/ToolActivate.js';


/**
 * @private
 */
export class Orbis360Controller {

	/**
	* @param {!angular.Scope} $scope Scope.
	* @param {!ngeo.FeatureOverlayMgr} ngeoFeatureOverlayMgr Ngeo FeatureOverlay
	*     manager.
	* @param {!ngeo.ToolActivateMgr} ngeoToolActivateMgr Ngeo ToolActivate manager
	*     service.
	* @private
	* @ngInject
	* @ngdoc controller
	* @ngname NgeoInfra3dController
	*/
	constructor($scope, ngeoFeatureOverlayMgr, ngeoToolActivateMgr) {

		this.active;

		$scope.$watch(
			() => this.active,
			this.handleActiveChange_.bind(this)
		);
		this.map;
		this.orbis360Client;
		this.username;
		this.password;
		this.publication;
		this.publicationid;
		this.scope_ = $scope;
		this.ngeoToolActivateMgr_ = ngeoToolActivateMgr;
		this.orbis360Initialized_ = false;
		this.location_ = null;
		// Cursor on geomapfish map
		this.featureOverlay_ = ngeoFeatureOverlayMgr.getFeatureOverlay();
		this.feature_ = new olFeature();
		this.point_ = new olGeomPoint([0, 0]);
		this.feature_.setGeometry(this.point_);
		
		
		this.handleMapClickListenerKey_ = null;
		// Draw layer while mesuring element
		this.drawFeature_ = new olFormatGeoJSON();
		this.drawSource_ = new olSourceVector();
		this.drawLayer_ = new olLayerVector({
			source: this.drawSource_,
			style: this.getGeojsonStyle
		});
		
		// Media layer
		this.mediaFeature_ = new olFormatGeoJSON();
		this.mediaSource_ = new olSourceVector();
		this.mediaLayer_ = new olLayerVector({
			source: this.mediaSource_,
			style: new olStyleStyle({
				stroke: new olStyleStroke({color: '#3665CF', width: 2})
			})
		})
	}

	  // Call once at geomapfish loading
	  $onInit() {
		console.log("component - oninit");
		this.scope_.$watch(
			() => this.location_,
			this.handleLocationChange_.bind(this)
		);
		
		// (2) Watch for both the active and location. When we have both, the
		//     state is considered 'ready'.
		this.scope_.$watch(
		() => {
			const isActive = this.active;
			const hasLocation = this.location_ !== null;
			return isActive && hasLocation;
		},
		this.handleReadyChange_.bind(this)
		);
	}

	// call when tool active is
	initComponent_() {
		// console.log("component - init");
		// Initialize location with current center of map.
		this.location_ = this.map.getView().getCenter() || [0, 0];
		this.point_.setCoordinates(this.location_);
		this.featureOverlay_.addFeature(this.feature_);
		this.map.addLayer(this.drawLayer_);
		this.map.addLayer(this.mediaLayer_);
		
		// Infra3D iframe options
		const divId = 'orbis360';
		const div = document.getElementById(divId);
		const orbis360Options = {
		  'easting': this.location_[0],
		  'northing': this.location_[1],
		  'epsg': 2056,
		  'map': false,
		  'layer': false,
		  'navigation': false
		};
		window.orbis360.init(divId, this.orbis360Client, this.password, this.username, this.publication, this.publicationid, this.map.getView().getCenter()[0], this.map.getView().getCenter()[1], orbis360Options, () => {
			window.orbis360.setOnPositionChanged(this.handleOrbis360OnPositionChanged, this);
			window.orbis360.setOnDrawFinished(this.handleOrbis360OnDrawFinished, this);
			window.orbis360.setOnDrawStopped(this.handleOrbis360OnDrawStopped, this);
			window.orbis360.setOnMediaLoaded(this.handleOrbis360OnOnMediaLoaded, this);
			this.orbis360Initialized_ = true;
		}, this);
	}

	handleMapClick_(evt) {
		if (this.orbis360Initialized_) {
			// update pointer on map
			this.location_ = evt.coordinate;
			this.scope_.$apply();

			// send location to orbis360
			window.orbis360.loadAtPosition(this.location_[0], this.location_[1], {
				'epsg': 2056
			});
		}
	}

	handleLocationChange_(location, oldLocation) {
		// Don't update if new location is empty
		console.log("handleLocationChange_");
		if (location === null) {
			return;
		}

		// No need to do anything if the old value equals the new value
		if (oldLocation !== null && equals(location, oldLocation)) {
			return;
		}

		// Update point coordinates
		this.point_.setCoordinates(location);
	}

	handleOrbis360OnPositionChanged(x, y, orientation, fieldOfView) {
		var mm = (Math.random() * (0.000200 - 0.000900) + 0.000900); // hack to make scope changed and update orientation on cursor map (gmf)
		this.location_ = /** @type{ol.Coordinate} */ ([x+mm, y+mm]);
		// Set icon orientation
		let rotation = orientation;// - 45; // icon image offset
		rotation = ((rotation % 360) + 360) % 360; // modulo 360 to enforce positive result
		rotation *= Math.PI / 180; // convert to radians*/
		//this.textStyle_.setRotation(rotation);
		//this.arcImage_.setRotation(rotation);
		
		// Create map icon
		// Create canveas for map icon with direction
		var canvas = document.createElement('canvas');
		canvas.width = 100;
		canvas.height = 100;
		var context = canvas.getContext('2d');
		context.clearRect(0, 0, canvas.width, canvas.height); //Clean current icon
		var centerX = canvas.width / 2;
		var centerY = canvas.height / 2;
		var radius = canvas.width / 4;
		var oneDeg = Math.PI*2*1/360;
		var startingAngle = (-Math.PI/2)-(fieldOfView/2*oneDeg)
		var endingAngle = (-Math.PI/2)+(fieldOfView/2*oneDeg);
		var counterclockwise = false;
		
		context.moveTo(centerX, centerY);
		context.arc(centerX, centerY, radius, startingAngle, endingAngle, counterclockwise);
		context.fillStyle = '#DC2228';
		context.fill();	
		this.arcImage_ = new olStyleIcon({
			img: canvas,
			imgSize: [canvas.width, canvas.height],
			rotation: rotation
		});
		this.arcStyle_ = new olStyleStyle({
			image: this.arcImage_
 
		});
		this.feature_.setStyle(this.arcStyle_);
		
		// Center geomapfish map
		this.map.getView().setCenter([x, y]);
		this.scope_.$apply();
	}
	
	// On draw finished, clean other draw and display new one
	handleOrbis360OnDrawFinished(geojson) {
		console.log("handleOrbis360OnDrawFinished");
		this.drawSource_.clear();
		var features = this.drawFeature_.readFeatures(geojson);
		// temporaly disable draw on 2d map due to bug of geom refresh
		this.drawSource_.addFeatures(features);
	}
	
	getGeojsonStyle(feature) {
		var fillStyle = new olStyleFill({color: 'transparent'});
		var strokeStyle = new olStyleStroke({color: '#DC2228', width: 3.0});
		var textStyle = new olStyleText({
			textAlign: 'center',
			textBaseline: 'bottom',
			placement: 'LINE',
			font: '12px Verdana',
			text: feature.get('label'),
			fill: new olStyleFill({color: '#FFFFFF'}),
			stroke: new olStyleStroke({color: '#DC2228', width: 3.0}),
			overflow: true
		});
		var styles = {
			'Point': new olStyleStyle({
				image: new olStyleCircle({
					radius: 5,
					fill: fillStyle,
					stroke: strokeStyle,
				}),
				text: textStyle,
			}),
			'LineString': new olStyleStyle({
				stroke: strokeStyle,
				text: textStyle,
			}),
			'Polygon': new olStyleStyle({
				stroke: strokeStyle,
				fill: fillStyle,
				text: textStyle,
			}),
		};
		return styles[feature.getGeometry().getType()];
	}
	
	handleOrbis360OnDrawStopped() {
		console.log("handleOrbis360OnDrawStopped");
		//this.drawSource_.clear();
	}
	
	handleOrbis360OnOnMediaLoaded(geojson) {
		console.log("handleOrbis360OnOnMediaLoaded");
		this.mediaSource_.clear();
		var availableData = this.mediaFeature_.readFeatures(geojson);
		this.mediaSource_.addFeatures(availableData);
		this.location_ = this.map.getView().getCenter() || [0, 0];
	}

	// Orbis360 tool active (open) or not
	handleActiveChange_(active) {
		if (active) {
			if (!this.orbis360Initialized_) {
			this.initComponent_();
			}
			this.handleMapClickListenerKey_ = listen(
				this.map,
				olEventsEventType.CLICK,
				this.handleMapClick_,
				this
			);
		} else {
			unByKey(this.handleMapClickListenerKey_);
			this.handleMapClickListenerKey_ = null;
		}
	}
	
	handleReadyChange_(ready, oldReady) {
		if (ready === oldReady) {
			return;
		}

		if (ready) {
			// Add current position to feature overlay
			this.featureOverlay_.addFeature(this.feature_);
			this.drawLayer_.setVisible(true);
			this.mediaLayer_.setVisible(true);

			// Display available media
			//this.ennLayer_.setVisible(true);

		} else {
			// Remove current position from feature overlay
			this.featureOverlay_.removeFeature(this.feature_);
			this.drawLayer_.setVisible(false);
			this.mediaLayer_.setVisible(false);
		}
	}
}


const name = 'rudazOrbis360';
const module = angular.module(name, []).component(name, {
  bindings: {
    'active': '<',
    'map': '<',
    'orbis360Client': '<',
    'username': '<',
    'password': '<',
    'publication': '<',
    'publicationid': '<'
  },
  controller: Orbis360Controller,
  template: '<div id="orbis360"></div>'
});

export default  module;
